export default Object.freeze({
  CAROUSEL: 'carousel',
  STATIC: 'static'
})



// WEBPACK FOOTER //
// ./src/enums/speakers_list_layout.js